const highlightComments = (object, item) =>
  object.comments && object.comments.filter(comment => comment.item === item).length > 0;

const formatAsCommentItem = (...args) => args.join('.');

const splitItemAsStep = item => item.split('.').slice(1, 3);

export { highlightComments, formatAsCommentItem, splitItemAsStep };
